import generify from './generic'

export const segments = generify('experiences-service', 'segments', 'segment')

segments.getFromExperience = (experienceUid, showDeleted) => {
  return segments.getFrom('experiences', experienceUid, showDeleted)
}

export default segments
